import * as yup from 'yup'

export const referenceSchema = (t, minRequired = 1) =>
  yup.object({
    references: yup
      .array()
      .of(
        yup.object({
          fullname: yup.string().required(t('reference.fullnameRequired')),
          jobTitle: yup.string().required(t('reference.jobTitleRequired')),
          companyName: yup
            .string()
            .required(t('reference.companyNameRequired')),
          email: yup
            .string()
            .email(t('reference.emailInvalid'))
            .required(t('reference.emailRequired')),
          phone: yup
            .string()
            .required(t('reference.phoneRequired'))
            .matches(/^$|^\d{10,12}$/, t('reference.phoneInvalid')),
          candidateRelationship: yup
            .string()
            .required(t('reference.relationshipRequired')),
          workDuration: yup
            .string()
            .required(t('reference.workDurationRequired')),
        }),
      )
      .min(
        minRequired,
        t('reference.minReferencesRequired', { count: minRequired }),
      ),
    consent: yup.boolean().oneOf([true], t('reference.consentRequired')),
  })
